import { Bill } from 'app/api/apiClient/settlement/types';
import { useGetPayor } from 'app/api/hooks/core/v1/payee/payors';
import { getLanguage } from 'app/utils/lib/i18n';
import { formatCurrency } from 'app/utils/lib/number';

interface Props {
  bill: Bill;
  hasMultiCurrency: boolean;
}

// Component Definition
const PayeePaperworkCurrencyText = ({ bill, hasMultiCurrency }: Props) => {
  const { data: payorData } = useGetPayor(bill.payorId);

  const currencyTypeName = payorData?.payor?.currencyType?.name ?? 'USD';

  const amount = formatCurrency(Number(bill.totalAmount), currencyTypeName);

  return hasMultiCurrency && getLanguage() !== 'en-CA' ? `${currencyTypeName} ${amount}` : amount;
};

export default PayeePaperworkCurrencyText;
